import React from 'react';

import { useTitle } from 'src/hooks/useTitle';

import { ServiceMetrics } from '../ServiceMetrics';

export const AmfMetrics: React.FC = () => {
    useTitle('AMF Metrics');

    return (
        <ServiceMetrics
            serviceName="AMF"
            title="AMF Licensing KPI's"
            description="View and analyze detailed AMF licensing KPI's - STEMP level data with advanced filtering and export capabilities"
            serviceId={3}
        />
    );
};
